import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { ToxicSumRuleInput, UpdateSumRuleMutation, UpdateSumRuleMutationVariables } from '~/graphql';
import { handleApolloError } from '~/utils';

import * as queries from '../toxicLimits.queries';

type ToxicSumRuleUpdateFunc = (input: ToxicSumRuleInput) => Promise<unknown>;

export const useToxicSumRuleUpdate = (id: string): [ToxicSumRuleUpdateFunc, boolean] => {
    const [callMutation, mutationResult] = useMutation<UpdateSumRuleMutation, UpdateSumRuleMutationVariables>(
        queries.UpdateSumRuleMutation,
        {
            refetchQueries: [
                {
                    query: queries.ToxicLimitsQuery,
                },
            ],
        }
    );

    const update: ToxicSumRuleUpdateFunc = useCallback(
        input => callMutation({ variables: { id, input } }).catch(handleApolloError),
        [id, callMutation]
    );

    return [update, mutationResult.loading];
};
